import { render, staticRenderFns } from "./paypage.vue?vue&type=template&id=aec72ab4&scoped=true&"
import script from "./paypage.vue?vue&type=script&lang=js&"
export * from "./paypage.vue?vue&type=script&lang=js&"
import style0 from "./paypage.vue?vue&type=style&index=0&id=aec72ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec72ab4",
  null
  
)

export default component.exports